<template>
  <div style="padding-top: 9%;">
    <div class="dependent maxW">
      <i class="ipng image_state01"></i>
      <p>- {{ $t('global.noDataTable') }} -</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

.dependent {
    // background-color: #fff;
    text-align: center;
    width: 100%;
    // height: 300px;
    overflow: hidden;
    margin-bottom: 50px;
    padding-top: 30px;

    p {
        color: #999;
        margin: 40px 0;
    }
}
</style>